import { _t } from '@/i18n/t';
import { showErrorMessage } from '@/shared/adapters/toast';
import { formatShortDate } from '@/features/visibility-report/utils/reportFormat';

interface RescanRefusalBody {
  errorCode?: string;
  unlocksOn?: string | null;
}

export const notifyRescanRefused = (body: RescanRefusalBody): boolean => {
  if (body.errorCode === 'RESCAN_LOCKED' && body.unlocksOn) {
    showErrorMessage(_t('rescan.locked', { date: formatShortDate(body.unlocksOn) }));
    return true;
  }
  if (body.errorCode === 'SCAN_RUNNING') {
    showErrorMessage(_t('rescan.running'));
    return true;
  }
  if (body.errorCode === 'EVALUATION_PLAN_LIMIT') {
    showErrorMessage(_t('rescan.upgradeRequired'));
    return true;
  }
  return false;
};

export default notifyRescanRefused;
